export enum ExperienceType {
  NEWBORN,
  INFANT,
  TODDLER,
  PRESCHOOL,
  MEDDLE_SCHOOL,
  TEEN,
  MULTIPLE_CHILDREN
}
